import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import styles from './Verification.module.css';
import { t } from '../../i18n';

const Verification = () => {
  const { usrId, uniqueString } = useParams();
  const navigate = useNavigate();
  const [verificationStatus, setVerificationStatus] = useState({
    loading: true,
    error: false,
    message: '',
  });

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        if (!usrId || !uniqueString) {
          setVerificationStatus({
            loading: false,
            error: true,
            message: t('ui.verification.invalidLink'),
          });
          return;
        }

        const response = await fetch(`/api/auth/verifyEmail/${usrId}/${uniqueString}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });

        const data = await response.json();

        if (response.ok) {
          setVerificationStatus({
            loading: false,
            error: false,
            message: data.message || t('ui.verification.success'),
          });
        } else {
          setVerificationStatus({
            loading: false,
            error: true,
            message: data.message || t('ui.verification.failed'),
          });
        }
      } catch {
        setVerificationStatus({
          loading: false,
          error: true,
          message: t('ui.verification.genericFail'),
        });
      }
    };

    verifyEmail();
  }, [usrId, uniqueString]);

  if (verificationStatus.loading) {
    return (
      <div className={styles.container}>
        <div className={styles.card}>
          <h2>{t('ui.verification.inProgress')}</h2>
          <div className={styles.loader}></div>
        </div>
      </div>
    );
  }

  return (
    <div className={`${styles.container} ${verificationStatus.error ? styles.errorContainer : ''}`}>
      <div className={`${styles.card} ${verificationStatus.error ? styles.error : styles.success}`}>
        <h2>{verificationStatus.error ? t('ui.verification.failed') : t('ui.verification.success')}</h2>
        <div className={`${styles.icon} ${styles.animated}`}>
          {verificationStatus.error ? (
            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16">
              <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"/>
            </svg>
          ) : (
            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16">
              <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
            </svg>
          )}
        </div>
        <p>{verificationStatus.message}</p>
        {!verificationStatus.error && (
          <button 
            className={styles.loginButton}
            onClick={() => navigate('/login')}
          >
            {t('ui.verification.goToLogin')}
          </button>
        )}
      </div>
    </div>
  );
};

export default Verification; 